<script>
import { reactive } from "vue";
import { useForm } from '@inertiajs/vue3'
import { Head, Link, router } from '@inertiajs/vue3';
import BreezeLayout from '@/Layouts/Authenticated.vue';
import BreezeButton from '@/Components/Button.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';

export default {
    components: {
        BreezeLayout,
        BreezeButton,
        BreezeInput,
        BreezeLabel,
        Head,
        Link
    },
    props: {

    },
    setup(props) {
        const form = useForm({
            file: null
        });

        const upload = () => {
             form.post(route('users.handleimport'))
        };

        return {
            form,
            upload
        };
    },
}
</script>

<template>
    <Head title="User import"/>

    <BreezeLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight flex">
                <Link :href="route('users.index')">Users</Link>
            </h2>

        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-gray-100">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <div class="mt-10 sm:mt-0">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1 flex justify-between flex-col">
                                    <div class="px-4 sm:px-0">
                                        <h3 class="text-lg font-medium leading-6 text-gray-900">Import users</h3>
                                        <p class="mt-2 text-sm text-gray-600">
                                            Tips:
                                        </p>
                                        <ul class="mt-1 text-sm text-gray-600 list-disc">
                                            <li class="ml-5 mb-2">Please doublecheck the file. 1 line per row.</li>
                                            <li class="ml-5 mb-2">Separator can be either <strong>,</strong> or <strong>;</strong> They will be autodetected.</li>
                                            <li class="ml-5 mb-2">Fields or headings with spaces need to be enclosed in "</li>
                                        </ul>
                                    </div>
                                    <div class="pb-2">
                                        <Link :href="route('users.index')" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-slate-400 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-600">← BACK</Link>
                                    </div>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <form @submit.prevent="upload">
                                        <div class="shadow overflow-hidden sm:rounded-md">
                                            <div class="px-4 py-5 bg-white sm:p-6 relative">
                                                <div class="grid grid-cols-6 gap-6">
                                                    <div class="col-span-6 sm:col-span-4">
                                                        <BreezeLabel
                                                            for="file"
                                                            value="User import file" />
                                                        <input
                                                            id="file"
                                                            type="file"
                                                            @input="form.file = $event.target.files[0]"
                                                            class="mt-1 p-1 bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                            required />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex justify-end px-4 py-3 bg-gray-50 text-right sm:px-6">
                                                <BreezeButton
                                                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                    :class="{ 'opacity-25': form.processing }"
                                                    :disabled="form.processing">
                                                    Upload
                                                </BreezeButton>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BreezeLayout>
</template>
